import { render } from "./BookForm.vue?vue&type=template&id=a3a6fab2&scoped=true"
import script from "./BookForm.vue?vue&type=script&lang=js"
export * from "./BookForm.vue?vue&type=script&lang=js"

import "./BookForm.vue?vue&type=style&index=0&id=a3a6fab2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3a6fab2"

export default script